export default class ModalDroitController {
	/* @ngInject */
	/**
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {any} node
	 * @param {any} edit
	 */
	constructor($uibModalInstance, node, edit) {
		this.$uibModalInstance = $uibModalInstance;
		this.node = node;
		this.edit = edit;
	}

	cancel() {
		this.$uibModalInstance.dismiss('cancel');
	}

	update() {
		this.$uibModalInstance.close(this.node);
	}
}

// /**
//  * @ngdoc function
//  * @name app.controller:ModalDroitCtrl
//  * @description
//  * # ModalDroitCtrl
//  * Controller of the app
//  */
// angular.module('app')
// 	.controller('ModalDroitCtrl',  function ($scope, ) {
// 		$scope.node = { ...node };
//
// 		$scope.edit = edit;
//
// 		$scope.update = () => {
// 			$uibModalInstance.close($scope.node);
// 		};
//
// 		$scope.cancel = () => {
//
// 		};
// 	});
